/**
 * Nested dialogs (Confirm inside Manage, etc.) each registered Escape before.
 * Only the topmost open modal should close on Escape.
 */

type EscapeHandler = () => void;

const stack: EscapeHandler[] = [];
let listening = false;

function onDocumentEscape(e: KeyboardEvent) {
  if (e.key !== 'Escape') return;
  const top = stack[stack.length - 1];
  if (!top) return;
  e.preventDefault();
  top();
}

export function pushModalEscapeHandler(handler: EscapeHandler): () => void {
  stack.push(handler);
  if (!listening) {
    document.addEventListener('keydown', onDocumentEscape);
    listening = true;
  }
  return () => {
    const index = stack.lastIndexOf(handler);
    if (index >= 0) stack.splice(index, 1);
    if (stack.length === 0 && listening) {
      document.removeEventListener('keydown', onDocumentEscape);
      listening = false;
    }
  };
}

/** Test helper */
export function resetModalEscapeStack(): void {
  stack.length = 0;
  if (listening) {
    document.removeEventListener('keydown', onDocumentEscape);
    listening = false;
  }
}
